// Main javascript entry point
// Should handle bootstrapping/starting application

'use strict';

import Hero from '../_modules/hero/hero';
import Services from '../_modules/services-slider/services-slider';
import Slider from '../_modules/slider/slider';
import Menu from '../_modules/menu/menu';
import Content from '../_modules/content/content';
import Companies from '../_modules/companies/companies';
import CompaniesQuotation from '../_modules/companies-quotation/companies-quotation';
import Clients from '../_modules/clients/clients';
import Whatsapp from '../_modules/whatsapp/whatsapp';

document.addEventListener('DOMContentLoaded', function() {
  new Menu();
  if (window.location.pathname === '/'){
    // Main Page
    new Hero();
    new Services();
    new Slider();
    new Content();
    new Clients();
    new Whatsapp();
  }
  else {
    // Companies Page
    new Companies();
    new CompaniesQuotation();
  }
});
